"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[664],{

/***/ 71876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ MarketingLayout; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/analytics/src/index.ts + 42 modules
var src = __webpack_require__(64043);
// EXTERNAL MODULE: ../../packages/plasmic-chilipiper/src/index.ts + 7 modules
var plasmic_chilipiper_src = __webpack_require__(56111);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/old-marketing/components/globals/footers/DefaultFooter.tsx + 2 modules
var DefaultFooter = __webpack_require__(64774);
// EXTERNAL MODULE: ../../node_modules/@air/icons/dist/icons.esm.js
var icons_esm = __webpack_require__(74398);
// EXTERNAL MODULE: ../../packages/primitives/src/index.tsx + 20 modules
var primitives_src = __webpack_require__(89170);
// EXTERNAL MODULE: ../../packages/marketing-tech-debt/src/components/dialogs/DemoDialog.tsx + 5 modules
var DemoDialog = __webpack_require__(46445);
// EXTERNAL MODULE: ../../node_modules/@air/zephyr/dist/zephyr.esm.js + 90 modules
var zephyr_esm = __webpack_require__(55164);
// EXTERNAL MODULE: ../../node_modules/@react-aria/overlays/dist/module.js + 1 modules
var dist_module = __webpack_require__(1328);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/framer-motion.es.js + 37 modules
var framer_motion_es = __webpack_require__(77665);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(42708);
// EXTERNAL MODULE: ./src/old-marketing/components/globals/Container.tsx
var Container = __webpack_require__(56083);
;// CONCATENATED MODULE: ./src/old-marketing/components/globals/headers/DefaultHeader/DefaultHeader.styles.ts

var Root = (0,primitives_src/* styled */.zo)("header", {
    zIndex: 4,
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "stretch",
    backgroundColor: "white",
    width: "100%",
    height: 80,
    transition: "background-color 0.2s ease, box-shadow 0.2s ease",
    perspective: 800
});
var Navigation = (0,primitives_src/* styled */.zo)("nav", {
    display: "flex",
    alignItems: "center",
    height: "100%"
});

// EXTERNAL MODULE: ./src/old-marketing/components/globals/Logo.tsx + 1 modules
var Logo = __webpack_require__(10622);
// EXTERNAL MODULE: ./src/old-marketing/components/Container.tsx + 1 modules
var components_Container = __webpack_require__(29654);
;// CONCATENATED MODULE: ./src/old-marketing/components/Header/HeaderMenu.styles.ts


var StyledHeaderMenu = (0,primitives_src/* styled */.zo)(framer_motion_es/* motion.div */.ww.div, {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    width: "100%",
    backgroundColor: "white",
    paddingTop: 40,
    paddingBottom: 20,
    borderBottomRightRadius: 10,
    borderBottomLeftRadius: 10,
    boxShadow: "0 10px 10px rgba(0, 0, 0, 0.06)",
    transformStyle: "preserve-3d",
    transformOrigin: "top",
    overflow: "hidden"
});

;// CONCATENATED MODULE: ./src/old-marketing/components/Header/HeaderMenuBackground.styles.tsx

var HeaderMenuBackground_styles_Root = (0,primitives_src/* styled */.zo)("svg", {
    zIndex: -1,
    position: "absolute",
    right: "calc(clamp(0px, 65vw, 900px) * -1)",
    bottom: "calc(clamp(0px, 13.19vw, 190px) * -1)",
    display: "block",
    width: "clamp(0px, 115.72vw, 1666px)"
});

// EXTERNAL MODULE: ./src/old-marketing/constants/testIds.ts
var testIds = __webpack_require__(50580);
;// CONCATENATED MODULE: ./src/old-marketing/components/Header/HeaderMenuBackground.tsx




var HeaderMenuBackground = function(param) {
    var css = param.css;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuBackground_styles_Root, {
        "data-testid": testIds/* HEADER_MENU_BACKGROUND */.xD,
        css: css,
        viewBox: "0 0 1668 740",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1667 582.167C1667 495.99 1597.07 425.88 1511.1 425.88H1432.43C1368.81 425.88 1317.33 374.271 1317.33 310.49V303.674C1317.33 136.189 1181.83 0.837402 1015.24 0.837402C848.177 0.837402 713.164 136.676 713.164 303.674C713.164 384.496 647.599 450.224 566.98 450.224H338.719C300.352 450.224 269.27 481.384 269.27 519.847C269.27 551.494 243.53 577.785 211.476 577.785H78.8906C35.6668 577.785 0.699219 612.84 0.699219 656.172V658.607C0.699219 702.912 36.6381 739.428 81.3189 739.428H1511.1C1597.07 738.941 1667 668.831 1667 582.167Z",
            fill: "currentColor"
        })
    });
};

;// CONCATENATED MODULE: ./src/old-marketing/components/Header/HeaderMenuItem.styles.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var HEADER_MENU_ITEM_ELEMENT_TAG = "a";
var StyledHeaderMenuItem = (0,primitives_src/* styled */.zo)(HEADER_MENU_ITEM_ELEMENT_TAG, {
    display: "flex",
    paddingY: 4,
    textDecoration: "none",
    "&:hover": /**
     * Targets and applies the underline to only the title
     */ _defineProperty({}, "& ".concat(primitives_src/* Text */.xv), {
        "&:first-of-type": {
            textDecoration: "underline"
        }
    })
});

;// CONCATENATED MODULE: ./src/old-marketing/components/Header/HeaderMenuItem.tsx






var HeaderMenuItem = function(param) {
    var adornment = param.adornment, css = param.css, description = param.description, href = param.href, name = param.name;
    var trackClickedActionItem = (0,src/* useTrackClickedActionItem */.Nw)().trackClickedActionItem;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeaderMenuItem, {
            "data-testid": testIds/* HEADER_MENU_ITEM */.iP,
            css: css,
            onClick: function() {
                return trackClickedActionItem({
                    destination: href,
                    destinationType: "internal",
                    location: window.location.href,
                    name: name,
                    pathName: window.location.pathname,
                    zone: "marketing",
                    version: "new-marketing-header"
                });
            },
            children: [
                adornment && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Box */.xu, {
                    css: {
                        marginRight: 12
                    },
                    children: adornment
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives_src/* Box */.xu, {
                    children: [
                        name && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Text */.xv, {
                            css: {
                                marginBottom: 2,
                                color: "$pigeon900",
                                fontWeight: "$semibold"
                            },
                            size: "ui-16",
                            children: name
                        }),
                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Text */.xv, {
                            css: {
                                color: "$pigeon600"
                            },
                            size: "ui-14",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/old-marketing/components/Header/HeaderMenu.tsx
function HeaderMenu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HeaderMenu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var TEMPLATE_COLUMNS = {
    enterprise: "minmax(auto, 548px) minmax(auto, 234px) minmax(auto, 300px)",
    product: "minmax(auto, 350px) minmax(auto, 400px) minmax(auto, 376px)",
    resources: "minmax(auto, 170px) minmax(auto, 170px) minmax(auto, 200px) minmax(auto, 400px)",
    "why-air": "minmax(auto, 250px) minmax(auto, 160px) minmax(auto, 220px) minmax(auto, 376px)"
};
var HeaderMenu = function(param) {
    var color = param.color, columns = param.columns, onDemoDialogOpen = param.onDemoDialogOpen, _template = param.template, template = _template === void 0 ? "product" : _template;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeaderMenu, {
        animate: {
            rotateX: 0,
            opacity: 1
        },
        "data-testid": testIds/* HEADER_MENU */.kW,
        initial: {
            rotateX: -10,
            opacity: 0
        },
        transition: {
            type: "spring",
            stiffness: 100
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Container/* Container */.W, {
                tx: {
                    display: "grid",
                    gridTemplateColumns: TEMPLATE_COLUMNS[template],
                    gridColumnGap: 20,
                    justifyContent: "space-evenly"
                },
                children: columns === null || columns === void 0 ? void 0 : columns.map(function(column, index1) {
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives_src/* Box */.xu, {
                        css: _objectSpread({
                            borderRight: column.hasDivider ? "1px solid" : undefined,
                            borderRightColor: "$pigeon100",
                            paddingRight: column.hasDivider ? 20 : 0,
                            "&:last-child": {
                                paddingRight: 0
                            }
                        }, column.css),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Text */.xv, {
                                css: {
                                    marginBottom: 20,
                                    color: "$pigeon400"
                                },
                                size: "ui-14",
                                transform: "uppercase",
                                children: column.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Box */.xu, {
                                css: {
                                    display: "flex"
                                },
                                children: "children" in column ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: onDemoDialogOpen ? /*#__PURE__*/ (0,react.cloneElement)(column.children, {
                                        onDemoDialogOpen: onDemoDialogOpen
                                    }) : column.children
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: ((0,lodash.chunk)(column.items, (ref = column === null || column === void 0 ? void 0 : column.chunkSize) !== null && ref !== void 0 ? ref : 4) || []).map(function(chunk1, index2) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(primitives_src/* Box */.xu, {
                                            css: {
                                                width: "100%",
                                                marginRight: 12,
                                                "&:last-child": {
                                                    marginRight: 0
                                                }
                                            },
                                            children: chunk1 === null || chunk1 === void 0 ? void 0 : chunk1.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItem, {
                                                    adornment: item.adornment,
                                                    css: {
                                                        marginBottom: 12
                                                    },
                                                    description: item.description,
                                                    href: item.href,
                                                    name: item.name
                                                }, "menu-column-item-".concat(index));
                                            })
                                        }, "menu-column-chunk-".concat(index2));
                                    })
                                })
                            })
                        ]
                    }, "menu-column-".concat(index1));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuBackground, {
                css: {
                    color: color
                }
            })
        ]
    });
};
HeaderMenu.toString = function() {
    return ".".concat(StyledHeaderMenu.className);
};

;// CONCATENATED MODULE: ./src/old-marketing/components/Header/HeaderMobileHamburger.styles.ts


var HeaderMobileHamburger_styles_Root = (0,primitives_src/* styled */.zo)("button", {
    display: "block",
    flexShrink: 0,
    backgroundColor: "transparent",
    width: 40,
    height: 40,
    border: 0,
    borderRadius: 4,
    paddingX: 8,
    color: "$jay700",
    cursor: "pointer"
});
var Bar = (0,primitives_src/* styled */.zo)(framer_motion_es/* motion.div */.ww.div, {
    backgroundColor: "currentColor",
    height: 2,
    marginY: 6,
    transformOrigin: "center"
});

// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-visually-hidden/dist/index.module.js
var index_module = __webpack_require__(19401);
;// CONCATENATED MODULE: ./src/old-marketing/components/primitives/VisuallyHidden.ts

var VisuallyHidden = index_module/* Root */.f;

;// CONCATENATED MODULE: ./src/old-marketing/components/Header/HeaderMobileHamburger.tsx




var HeaderMobileHamburger = function(param) {
    var css = param.css, isOpened = param.isOpened, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderMobileHamburger_styles_Root, {
        css: css,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisuallyHidden, {
                children: "Menu"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar, {
                animate: {
                    rotate: isOpened ? 45 : 0,
                    y: isOpened ? 8 : 0
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar, {
                animate: {
                    width: isOpened ? 0 : "auto",
                    opacity: isOpened ? 0 : 1
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar, {
                animate: {
                    rotate: isOpened ? -45 : 0,
                    y: isOpened ? -8 : 0
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/old-marketing/components/Header/HeaderMobileMenu/HeaderMobileMenuNavigationItem.tsx
function HeaderMobileMenuNavigationItem_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function HeaderMobileMenuNavigationItem_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HeaderMobileMenuNavigationItem_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var HeaderMobileMenuNavigationItem = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var children = _param.children, tx = _param.tx, href = _param.href, restOfProps = _objectWithoutProperties(_param, [
        "children",
        "tx",
        "href"
    ]);
    var as = restOfProps.as || (href ? "a" : "div");
    var navItem = /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, HeaderMobileMenuNavigationItem_objectSpread({
        as: as,
        ref: ref,
        tx: HeaderMobileMenuNavigationItem_objectSpread({
            display: "flex",
            alignItems: "center",
            backgroundColor: "transparent",
            width: "100%",
            border: 0,
            p: 0,
            mb: 24,
            color: "jay700",
            fontWeight: "medium",
            textDecoration: "none",
            cursor: "pointer",
            "&:hover": {
                textDecoration: "underline"
            }
        }, tx),
        variant: "text-heading-24"
    }, restOfProps, {
        children: children
    }));
    if (as === "a" && !!href) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            passHref: true,
            children: navItem
        });
    }
    return navItem;
});

HeaderMobileMenuNavigationItem.displayName = "HeaderMobileMenuNavigationItem";

;// CONCATENATED MODULE: ./src/old-marketing/components/Header/HeaderMobileMenu/HeaderMobileMenuPanelNavigationItem.tsx
function HeaderMobileMenuPanelNavigationItem_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function HeaderMobileMenuPanelNavigationItem_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HeaderMobileMenuPanelNavigationItem_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function HeaderMobileMenuPanelNavigationItem_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = HeaderMobileMenuPanelNavigationItem_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function HeaderMobileMenuPanelNavigationItem_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var HeaderMobileMenuPanelNavigationItem = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var children = _param.children, leftAdornment = _param.leftAdornment, tx = _param.tx, restOfProps = HeaderMobileMenuPanelNavigationItem_objectWithoutProperties(_param, [
        "children",
        "leftAdornment",
        "tx"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Text */.xv, HeaderMobileMenuPanelNavigationItem_objectSpread({
        as: "a",
        ref: ref,
        tx: HeaderMobileMenuPanelNavigationItem_objectSpread({
            display: "flex",
            alignItems: "center",
            backgroundColor: "transparent",
            width: "100%",
            border: 0,
            mb: 12,
            color: "jay800",
            fontWeight: "semibold",
            textDecoration: "none",
            cursor: "pointer",
            "&:hover": {
                textDecoration: "underline"
            }
        }, tx),
        variant: "text-ui-16"
    }, restOfProps, {
        children: [
            leftAdornment && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                tx: {
                    mr: 12
                },
                children: leftAdornment
            }),
            children
        ]
    }));
});

HeaderMobileMenuPanelNavigationItem.displayName = "HeaderMobileMenuPanelNavigationItem";

;// CONCATENATED MODULE: ./src/old-marketing/components/Header/HeaderMobileMenu/HeaderMobileMenuPanel.tsx
function HeaderMobileMenuPanel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function HeaderMobileMenuPanel_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HeaderMobileMenuPanel_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var HEADER_MOBILE_MENU_PANEL_ANIMATION_VARIANTS = {
    closed: {
        x: -24,
        opacity: 0,
        transitionEnd: {
            display: "none"
        }
    },
    opened: {
        x: 0,
        display: "block",
        opacity: 1
    }
};
var HEADER_MOBILE_MENU_PANEL_REDUCED_ANIMATION_VARIANTS = {
    closed: {
        opacity: 0,
        height: "100%",
        transitionEnd: {
            display: "none"
        }
    },
    opened: {
        height: "100%",
        opacity: 1
    }
};
var HeaderMobileMenuPanel = function(param) {
    var isOpened = param.isOpened, name = param.name, navigation = param.navigation, _onClose = param.onClose, onClose = _onClose === void 0 ? lodash.noop : _onClose, tx = param.tx;
    var shouldReduceMotion = (0,framer_motion_es/* useReducedMotion */.JZ)();
    var trackClickedActionItem = (0,src/* useTrackClickedActionItem */.Nw)().trackClickedActionItem;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
        animate: isOpened ? "opened" : "closed",
        as: framer_motion_es/* motion.div */.ww.div,
        initial: {
            display: "none",
            x: -24,
            opacity: 0
        },
        transition: {
            duration: 0.2,
            type: "tween"
        },
        tx: HeaderMobileMenuPanel_objectSpread({
            position: "fixed",
            top: 80,
            right: 0,
            bottom: 0,
            left: 0,
            height: "calc(100% - 80px)",
            backgroundColor: "white",
            overflowY: "scroll",
            WebkitOverflowScrolling: "touch",
            py: 40,
            px: 32
        }, tx),
        variants: shouldReduceMotion ? HEADER_MOBILE_MENU_PANEL_REDUCED_ANIMATION_VARIANTS : HEADER_MOBILE_MENU_PANEL_ANIMATION_VARIANTS,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderMobileMenuNavigationItem, {
                as: "button",
                onClick: onClose,
                tx: {
                    mb: 24
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                        as: icons_esm/* ChevronLeft */.s$$,
                        tx: {
                            display: "block",
                            width: 24,
                            mr: 12
                        }
                    }),
                    name
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                tx: {
                    ml: 36
                },
                children: navigation === null || navigation === void 0 ? void 0 : navigation.map(function(newNavigation) {
                    var ref;
                    if (!newNavigation.items) {
                        return null;
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                        tx: {
                            mb: 32,
                            "last-child": {
                                mb: 0
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                                tx: {
                                    mb: 20,
                                    color: "pigeon900",
                                    fontWeight: "medium"
                                },
                                variant: "text-heading-20",
                                children: newNavigation.name
                            }),
                            newNavigation === null || newNavigation === void 0 ? void 0 : (ref = newNavigation.items) === null || ref === void 0 ? void 0 : ref.map(function(navigationItem) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: navigationItem.href,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobileMenuPanelNavigationItem, {
                                        onClick: function() {
                                            trackClickedActionItem({
                                                destination: navigationItem.href,
                                                destinationType: "internal",
                                                location: window.location.href,
                                                name: navigationItem.name,
                                                pathName: window.location.pathname,
                                                zone: "marketing"
                                            });
                                        },
                                        leftAdornment: navigationItem.adornment,
                                        children: navigationItem.name
                                    })
                                }, navigationItem.name);
                            })
                        ]
                    }, newNavigation.name);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/old-marketing/constants/Routes.ts
var Routes = __webpack_require__(46955);
;// CONCATENATED MODULE: ./src/old-marketing/components/Header/HeaderMobileMenu/HeaderMobileMenuSignUpBanner.tsx





var HeaderMobileMenuSignUpBanner = function() {
    var trackClickedActionItem = (0,src/* useTrackClickedActionItem */.Nw)().trackClickedActionItem;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
        tx: {
            display: "flex",
            alignItems: "center",
            flexDirection: [
                "column",
                "row"
            ],
            justifyContent: "space-between",
            backgroundColor: "jay050",
            p: 24,
            borderRadius: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                as: "h6",
                variant: "text-heading-24",
                tx: {
                    color: "jay700",
                    mb: [
                        24,
                        0,
                        0
                    ],
                    textAlign: "center"
                },
                children: "Get started in seconds, add your team as you go do more with your visual assets on Air!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: Routes/* AuthRoutes.signUp */.t5.signUp,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Button */.zx, {
                    as: "a",
                    onClick: function() {
                        trackClickedActionItem({
                            destination: Routes/* AuthRoutes.signUp */.t5.signUp,
                            destinationType: "internal",
                            location: window.location.href,
                            name: "Sign up for free",
                            pathName: window.location.pathname,
                            zone: "marketing"
                        });
                    },
                    size: "large",
                    variant: "button-filled-blue",
                    children: "Sign up for free"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/old-marketing/components/Header/HeaderMobileMenu/HeaderMobileMenu.tsx
function HeaderMobileMenu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function HeaderMobileMenu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HeaderMobileMenu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}










var HEADER_MOBILE_MENU_ANIMATION_VARIANTS = {
    closed: {
        height: 0,
        opacity: 0,
        transitionEnd: {
            display: "none"
        }
    },
    opened: {
        display: "flex",
        height: "100%",
        opacity: 1
    }
};
var HEADER_MOBILE_MENU_REDUCED_ANIMATION_VARIANTS = {
    closed: {
        opacity: 0,
        height: "100%",
        transitionEnd: {
            display: "none"
        }
    },
    opened: {
        height: "100%",
        opacity: 1
    }
};
var HeaderMobileMenu = function(param) {
    var isOpened = param.isOpened, navigation = param.navigation, tx = param.tx;
    var shouldReduceMotion = (0,framer_motion_es/* useReducedMotion */.JZ)();
    var ref1 = (0,react.useState)(0), openedPanel = ref1[0], setOpenedPanel = ref1[1];
    var trackClickedActionItem = (0,src/* useTrackClickedActionItem */.Nw)().trackClickedActionItem;
    /**
   * Resets panel when `isOpened` state is changed.
   */ (0,react.useEffect)(function() {
        setOpenedPanel(0);
    }, [
        isOpened
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
        animate: isOpened ? "opened" : "closed",
        as: framer_motion_es/* motion.div */.ww.div,
        initial: {
            height: 0,
            opacity: 0
        },
        transition: {
            duration: 0.4,
            type: "tween"
        },
        tx: HeaderMobileMenu_objectSpread({
            zIndex: 3,
            position: "fixed",
            inset: 0,
            display: "flex",
            backgroundColor: "white",
            pointerEvents: !isOpened ? "none" : "unset",
            height: "100%"
        }, tx),
        variants: shouldReduceMotion ? HEADER_MOBILE_MENU_REDUCED_ANIMATION_VARIANTS : HEADER_MOBILE_MENU_ANIMATION_VARIANTS,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
            tx: {
                flexGrow: 1,
                height: "calc(100% - 80px)",
                mt: 80,
                px: 32,
                pt: 40,
                pb: 40,
                overflowY: "scroll",
                WebkitOverflowScrolling: "touch"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                    as: "nav",
                    children: [
                        navigation === null || navigation === void 0 ? void 0 : navigation.map(function(navigationItem, index) {
                            var ref;
                            if (!!((ref = navigationItem.columns) === null || ref === void 0 ? void 0 : ref.length)) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                                            tx: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobileMenuNavigationItem, {
                                                    href: navigationItem.href,
                                                    onClick: function() {
                                                        if (navigationItem.href) {
                                                            trackClickedActionItem({
                                                                destination: navigationItem.href,
                                                                destinationType: "internal",
                                                                location: window.location.href,
                                                                name: navigationItem.name,
                                                                pathName: window.location.pathname,
                                                                zone: "marketing"
                                                            });
                                                        } else {
                                                            setOpenedPanel(index + 1);
                                                        }
                                                    },
                                                    children: navigationItem.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* IconButton */.hU, {
                                                    icon: icons_esm/* ChevronRight */._Qn,
                                                    hasTooltip: false,
                                                    onClick: function() {
                                                        return setOpenedPanel(index + 1);
                                                    },
                                                    tx: {
                                                        flexShrink: 0,
                                                        ml: 12,
                                                        color: "jay700"
                                                    },
                                                    size: "medium",
                                                    variant: "button-ghost-grey",
                                                    children: "Expand ".concat(navigationItem.name, " panel")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobileMenuPanel, {
                                            isOpened: openedPanel === index + 1,
                                            name: navigationItem.name,
                                            navigation: navigationItem.columns,
                                            onClose: function() {
                                                return setOpenedPanel(0);
                                            }
                                        })
                                    ]
                                }, index);
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobileMenuNavigationItem, {
                                href: navigationItem.href,
                                onClick: function() {
                                    if (navigationItem.href) {
                                        trackClickedActionItem({
                                            destination: navigationItem.href,
                                            destinationType: "internal",
                                            location: window.location.href,
                                            name: navigationItem.name,
                                            pathName: window.location.pathname,
                                            zone: "marketing"
                                        });
                                    }
                                },
                                children: navigationItem.name
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                            tx: {
                                backgroundColor: "pigeon100",
                                width: 40,
                                height: 1,
                                my: 40
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobileMenuNavigationItem, {
                            href: Routes/* AuthRoutes.login */.t5.login,
                            onClick: function() {
                                trackClickedActionItem({
                                    destination: Routes/* AuthRoutes.login */.t5.login,
                                    destinationType: "internal",
                                    location: window.location.href,
                                    name: "Log in",
                                    pathName: window.location.pathname,
                                    zone: "marketing"
                                });
                            },
                            children: "Log in"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobileMenuSignUpBanner, {})
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/old-marketing/components/Header/HeaderNavigationItem.styles.ts
function HeaderNavigationItem_styles_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var HEADER_NAVIGATION_ITEM_ELEMENT_TAG = "div";
var StyledHeaderNavigationItem = (0,primitives_src/* styled */.zo)(HEADER_NAVIGATION_ITEM_ELEMENT_TAG, HeaderNavigationItem_styles_defineProperty({
    display: "flex",
    alignItems: "center",
    height: "100%",
    marginRight: 12,
    paddingY: 4,
    paddingX: 8,
    color: "inherit",
    transition: "color 0.2s ease"
}, "& > ".concat(primitives_src/* Text */.xv), {
    color: "inherit",
    fontWeight: "$medium",
    textDecoration: "none"
}));

;// CONCATENATED MODULE: ./src/old-marketing/components/Header/HeaderNavigationItem.tsx






var HeaderNavigationItem = function(param) {
    var css = param.css, href = param.href, menu = param.menu, name = param.name, onBlur = param.onBlur, onClick = param.onClick, onFocus = param.onFocus, onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave, rightAdornment = param.rightAdornment;
    var trackClickedActionItem = (0,src/* useTrackClickedActionItem */.Nw)().trackClickedActionItem;
    var onNavItemClick = function() {
        trackClickedActionItem({
            destination: href,
            destinationType: "internal",
            location: window.location.href,
            name: name,
            pathName: window.location.pathname,
            zone: "marketing",
            version: "new-marketing-header"
        });
    };
    var navItem = undefined;
    if (href) {
        navItem = /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Text */.xv, {
                as: "a",
                onClick: onNavItemClick,
                size: "ui-16",
                css: {
                    whiteSpace: "nowrap",
                    cursor: "pointer"
                },
                children: name
            })
        });
    } else {
        navItem = /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Text */.xv, {
            onClick: onNavItemClick,
            size: "ui-16",
            css: {
                whiteSpace: "nowrap",
                cursor: "pointer"
            },
            children: name
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeaderNavigationItem, {
        css: css,
        "data-testid": testIds/* HEADER_NAVIGATION_ITEM */.rr,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        children: [
            navItem,
            rightAdornment,
            menu
        ]
    });
};

// EXTERNAL MODULE: ./src/old-marketing/constants/navigation.tsx + 4 modules
var constants_navigation = __webpack_require__(47181);
;// CONCATENATED MODULE: ./src/old-marketing/components/globals/headers/DefaultHeader/DefaultHeader.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}























var DefaultHeader = function(param) {
    var appearance = param.appearance, customButton = param.customButton, _ctaText = param.ctaText, ctaText = _ctaText === void 0 ? "Book a demo" : _ctaText, _hasAuthNavigation = param.hasAuthNavigation, hasAuthNavigation = _hasAuthNavigation === void 0 ? true : _hasAuthNavigation, _hasMobileNavigation = param.hasMobileNavigation, hasMobileNavigation = _hasMobileNavigation === void 0 ? true : _hasMobileNavigation, _hasDemoOnlyCTANavigation = param.hasDemoOnlyCTANavigation, hasDemoOnlyCTANavigation = _hasDemoOnlyCTANavigation === void 0 ? false : _hasDemoOnlyCTANavigation, _hasDemoOnlyCTANavigationOnMobile = param.hasDemoOnlyCTANavigationOnMobile, hasDemoOnlyCTANavigationOnMobile = _hasDemoOnlyCTANavigationOnMobile === void 0 ? false : _hasDemoOnlyCTANavigationOnMobile, _hasLogo = param.hasLogo, hasLogo = _hasLogo === void 0 ? true : _hasLogo, _hasNavigation = param.hasNavigation, hasNavigation = _hasNavigation === void 0 ? true : _hasNavigation, _isFixed = param.isFixed, isFixed = _isFixed === void 0 ? false : _isFixed, _isHiddenOnSticky = param.isHiddenOnSticky, isHiddenOnSticky = _isHiddenOnSticky === void 0 ? false : _isHiddenOnSticky, leadsource = param.leadsource, _navigation = param.navigation, navigation = _navigation === void 0 ? constants_navigation/* HEADER_NAVIGATION */.uT : _navigation, chilipiperRouter = param.router;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(undefined), activeMenu = ref[0], setActiveMenu = ref[1];
    var ref1 = (0,react.useState)(false), isMobileMenuOpened = ref1[0], setIsMobileMenuOpened = ref1[1];
    var ref2 = (0,react.useState)(false), isDemoDialogOpened = ref2[0], setIsDemoDialogOpened = ref2[1];
    var ref3 = _slicedToArray((0,react_intersection_observer/* useInView */.YD)(), 3), stickyRef = ref3[0], inView = ref3[1], entry = ref3[2];
    var isStickied = !inView && entry;
    var isMenuOpened = !(0,lodash.isUndefined)(activeMenu);
    var isLightText = appearance === "light" && !(isStickied && isFixed) && !isMobileMenuOpened && !isMenuOpened;
    var trackClickedActionItem = (0,src/* useTrackClickedActionItem */.Nw)().trackClickedActionItem;
    /**
   * Prevents the page from scrolling when the mobile menu is opened.
   */ (0,dist_module/* usePreventScroll */.tk)({
        isDisabled: !isMobileMenuOpened
    });
    /**
   * Closes the mobile menu when a route change is completed.
   */ (0,react.useEffect)(function() {
        var onMobileMenuClose = function() {
            return setIsMobileMenuOpened(false);
        };
        router.events.on("routeChangeComplete", onMobileMenuClose);
        return function() {
            return router.events.off("routeChangeComplete", onMobileMenuClose);
        };
    }, [
        router.events
    ]);
    /**
   * This closes the mobile menu when the window is resized.
   */ (0,react.useEffect)(function() {
        var onMobileMenuClose = function() {
            if (window.innerWidth > 1024) {
                setIsMobileMenuOpened(false);
            }
        };
        window.addEventListener("resize", onMobileMenuClose);
        return function() {
            return window.removeEventListener("resize", onMobileMenuClose);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Box */.xu, {
                ref: stickyRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Root, {
                "data-testid": testIds/* HEADER */.yf,
                css: {
                    position: isFixed ? "fixed" : "absolute",
                    backgroundColor: isStickied && isFixed || isMenuOpened ? "white" : "transparent",
                    boxShadow: isStickied && isFixed ? "0 4px 10px rgba(0, 0, 0, 0.06)" : "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                    css: {
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        height: "100%",
                        justifyContent: "space-between"
                    },
                    children: [
                        hasLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* Logo */.T, {
                            css: {
                                display: "block",
                                height: 32,
                                marginRight: 32,
                                color: isLightText ? "$white" : "$macaw600"
                            }
                        }),
                        hasNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation, {
                            css: {
                                flexGrow: 1,
                                display: "none",
                                color: isLightText ? "$white" : "$pigeon800",
                                transition: "opacity 0.2s ease",
                                paddingX: 12,
                                "@desktop": {
                                    display: "flex"
                                }
                            },
                            "data-testid": constants_navigation/* HEADER_NAVIGATION */.uT,
                            style: {
                                opacity: isHiddenOnSticky && isStickied ? 0 : 1,
                                pointerEvents: isHiddenOnSticky && isStickied ? "none" : "auto"
                            },
                            children: navigation.map(function(navItem, index) {
                                var hasMenu = navItem.columns;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavigationItem, {
                                    href: navItem.href,
                                    rightAdornment: hasMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Box */.xu, {
                                        animate: {
                                            rotate: isMenuOpened && activeMenu === index ? -180 : 0
                                        },
                                        as: framer_motion_es/* motion.div */.ww.div,
                                        css: {
                                            marginLeft: 4,
                                            transformOrigin: "center"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Box */.xu, {
                                            as: icons_esm/* ChevronDown */._ME,
                                            css: {
                                                display: "block",
                                                width: 16
                                            }
                                        })
                                    }),
                                    menu: navItem.columns && activeMenu === index && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenu, {
                                        color: navItem.color,
                                        columns: navItem.columns,
                                        onDemoDialogOpen: function() {
                                            return setIsDemoDialogOpened(true);
                                        },
                                        template: navItem.template
                                    }),
                                    name: navItem.name,
                                    onBlur: hasMenu ? function() {
                                        return setActiveMenu(undefined);
                                    } : lodash.noop,
                                    onFocus: hasMenu ? function() {
                                        return setActiveMenu(index);
                                    } : lodash.noop,
                                    onMouseEnter: hasMenu ? function() {
                                        return setActiveMenu(index);
                                    } : lodash.noop,
                                    onMouseLeave: hasMenu ? function() {
                                        return setActiveMenu(undefined);
                                    } : lodash.noop
                                }, index);
                            })
                        }),
                        hasAuthNavigation && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navigation, {
                            css: {
                                display: hasDemoOnlyCTANavigationOnMobile ? "flex" : "none",
                                color: isLightText ? "$white" : "$pigeon800",
                                "@desktop": {
                                    display: "flex"
                                }
                            },
                            "data-testid": constants_navigation/* HEADER_NAVIGATION */.uT,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavigationItem, {
                                    href: Routes/* AuthRoutes.login */.t5.login,
                                    name: "Login"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Button */.zx, {
                                    as: "a",
                                    "data-testid": testIds/* HEADER_NAVIGATION_BUTTON */.tx,
                                    onClick: function() {
                                        trackClickedActionItem({
                                            destinationType: "internal",
                                            location: window.location.href,
                                            name: "Sign up for free",
                                            pathName: window.location.pathname,
                                            zone: "marketing",
                                            version: "new-marketing-header"
                                        });
                                        setIsDemoDialogOpened(true);
                                    },
                                    tx: {
                                        mr: 12,
                                        color: isLightText ? "white" : undefined,
                                        "&:hover:not(:disabled)": {
                                            color: isLightText ? "white" : undefined
                                        },
                                        height: 36,
                                        paddingX: 12
                                    },
                                    variant: "button-outline-blue",
                                    children: "Book a demo"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: Routes/* AuthRoutes.signUp */.t5.signUp,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Button */.zx, {
                                        as: "a",
                                        "data-testid": testIds/* HEADER_NAVIGATION_BUTTON */.tx,
                                        onClick: function() {
                                            return trackClickedActionItem({
                                                destination: Routes/* AuthRoutes.signUp */.t5.signUp,
                                                destinationType: "internal",
                                                location: window.location.href,
                                                name: "Sign up for free",
                                                pathName: window.location.pathname,
                                                zone: "marketing",
                                                version: "new-marketing-header"
                                            });
                                        },
                                        tx: {
                                            height: 36,
                                            paddingX: 12
                                        },
                                        children: "Sign up for free"
                                    })
                                })
                            ]
                        }),
                        hasDemoOnlyCTANavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation, {
                            css: {
                                display: hasDemoOnlyCTANavigationOnMobile ? "flex" : "none",
                                color: isLightText ? "$white" : "$pigeon800",
                                "@desktop": {
                                    display: "flex"
                                }
                            },
                            "data-testid": constants_navigation/* HEADER_NAVIGATION */.uT,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Button */.zx, {
                                "data-testid": testIds/* HEADER_NAVIGATION_BUTTON */.tx,
                                "data-id": "book-a-demo",
                                onClick: function() {
                                    setIsDemoDialogOpened(true);
                                },
                                tx: {
                                    mr: 12,
                                    color: isLightText ? "white" : undefined,
                                    "&:hover:not(:disabled)": {
                                        color: isLightText ? "white" : undefined
                                    },
                                    height: 36,
                                    paddingX: 12
                                },
                                variant: "button-filled-blue",
                                children: ctaText
                            })
                        }),
                        customButton,
                        hasMobileNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobileHamburger, {
                            css: {
                                display: "block",
                                "@desktop": {
                                    display: "none"
                                }
                            },
                            isOpened: isMobileMenuOpened,
                            onClick: function() {
                                return setIsMobileMenuOpened(!isMobileMenuOpened);
                            }
                        })
                    ]
                })
            }),
            hasMobileNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobileMenu, {
                navigation: navigation,
                isOpened: isMobileMenuOpened
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DemoDialog/* DemoDialog */.d, {
                id: chilipiperRouter,
                isOpen: isDemoDialogOpened,
                leadsource: leadsource,
                onDismiss: function() {
                    return setIsDemoDialogOpened(false);
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/old-marketing/components/GlobalStyle.tsx
var GlobalStyle = __webpack_require__(14399);
// EXTERNAL MODULE: ../../node_modules/widont/index.js
var widont = __webpack_require__(19491);
var widont_default = /*#__PURE__*/__webpack_require__.n(widont);
// EXTERNAL MODULE: ./src/utils/getContentfulUrl.ts
var getContentfulUrl = __webpack_require__(86250);
;// CONCATENATED MODULE: ./src/old-marketing/components/PreviewModeBanner.tsx
function PreviewModeBanner_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PreviewModeBanner_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PreviewModeBanner_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function PreviewModeBanner_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = PreviewModeBanner_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function PreviewModeBanner_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var PreviewModeBanner = function(_param) {
    var id = _param.id, tx = _param.tx, restOfProps = PreviewModeBanner_objectWithoutProperties(_param, [
        "id",
        "tx"
    ]);
    var asPath = (0,next_router.useRouter)().asPath;
    var contentfulUrl = (0,getContentfulUrl/* getContentfulUrl */.H)(id);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, PreviewModeBanner_objectSpread({}, restOfProps, {
        tx: PreviewModeBanner_objectSpread({
            zIndex: 9999,
            position: "fixed",
            bottom: 24,
            left: 24,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            borderRadius: 4,
            maxWidth: "calc(100% - 48px)",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.06)",
            px: 24,
            py: 12,
            color: "white",
            pointerEvents: "none"
        }, tx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                tx: {
                    mr: 24
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                        tx: {
                            color: "inherit",
                            fontWeight: "semibold"
                        },
                        variant: "text-ui-14",
                        children: "Preview mode enabled"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                        tx: {
                            color: "inherit"
                        },
                        variant: "text-ui-14",
                        children: widont_default()("Click the button to the right to exit.")
                    })
                ]
            }),
            id && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Button */.zx, {
                as: "a",
                href: contentfulUrl,
                tx: {
                    pointerEvents: "initial",
                    whiteSpace: "nowrap",
                    mr: 8
                },
                variant: "button-outline-blue",
                children: "Edit in Contentful"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Button */.zx, {
                as: "a",
                href: "/api/preview/exit-preview?url=".concat(asPath),
                tx: {
                    pointerEvents: "initial",
                    whiteSpace: "nowrap"
                },
                children: "Exit preview"
            })
        ]
    }));
};


// EXTERNAL MODULE: ./src/providers/PreviewModeProvider.tsx
var PreviewModeProvider = __webpack_require__(71119);
// EXTERNAL MODULE: ./src/scripts/GoogleTagManager.tsx
var GoogleTagManager = __webpack_require__(50001);
;// CONCATENATED MODULE: ./src/layouts/MarketingLayout.tsx
function MarketingLayout_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function MarketingLayout_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MarketingLayout_defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var MarketingLayout = function(param) {
    var layout = param.layout, children = param.children;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var trackShowIntercomWidget = (0,src/* useTrackShowIntercomWidget */.rA)().trackShowIntercomWidget;
    var trackHideIntercomWidget = (0,src/* useTrackHideIntercomWidget */.MI)().trackHideIntercomWidget;
    (0,react.useEffect)(function() {
        if (layout === null || layout === void 0 ? void 0 : layout.enableIntercom) {
            trackShowIntercomWidget();
        } else {
            trackHideIntercomWidget();
        }
    }, [
        layout === null || layout === void 0 ? void 0 : layout.enableIntercom,
        trackShowIntercomWidget,
        trackHideIntercomWidget
    ]);
    var ref8, ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* AnalyticsProvider */.ng, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* AnalyticsPageRouting */.eQ, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewModeProvider/* PreviewModeProvider */.k, {
                value: {
                    isPreview: (ref8 = layout === null || layout === void 0 ? void 0 : layout.preview) !== null && ref8 !== void 0 ? ref8 : false
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyle/* GlobalStyle */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleTagManager/* GoogleTagManager */.f, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(plasmic_chilipiper_src/* ChilipiperScript */.hk, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, MarketingLayout_objectSpread({}, layout === null || layout === void 0 ? void 0 : layout.seo, {
                            noindex: layout === null || layout === void 0 ? void 0 : layout.noindex,
                            titleTemplate: "%s"
                        })),
                        (layout === null || layout === void 0 ? void 0 : layout.preview) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewModeBanner, {
                            id: layout === null || layout === void 0 ? void 0 : layout.id
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultHeader, {
                            appearance: (ref9 = layout === null || layout === void 0 ? void 0 : (ref = layout.header) === null || ref === void 0 ? void 0 : ref.appearance) !== null && ref9 !== void 0 ? ref9 : layout === null || layout === void 0 ? void 0 : (ref1 = layout.header) === null || ref1 === void 0 ? void 0 : ref1.variant,
                            hasAuthNavigation: layout === null || layout === void 0 ? void 0 : (ref2 = layout.header) === null || ref2 === void 0 ? void 0 : ref2.hasAuthNavigation,
                            hasDemoOnlyCTANavigation: layout === null || layout === void 0 ? void 0 : (ref3 = layout.header) === null || ref3 === void 0 ? void 0 : ref3.hasDemoOnlyCTANavigation,
                            hasMobileNavigation: layout === null || layout === void 0 ? void 0 : (ref4 = layout.header) === null || ref4 === void 0 ? void 0 : ref4.hasMobileNavigation,
                            hasNavigation: layout === null || layout === void 0 ? void 0 : (ref5 = layout.header) === null || ref5 === void 0 ? void 0 : ref5.hasNavigation,
                            isFixed: layout === null || layout === void 0 ? void 0 : (ref6 = layout.header) === null || ref6 === void 0 ? void 0 : ref6.isFixed,
                            isHiddenOnSticky: layout === null || layout === void 0 ? void 0 : (ref7 = layout.header) === null || ref7 === void 0 ? void 0 : ref7.isHiddenOnSticky
                        }),
                        children,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultFooter/* DefaultFooter */.q, {})
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 29654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ Container; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@air/zephyr/dist/zephyr.esm.js + 90 modules
var zephyr_esm = __webpack_require__(55164);
// EXTERNAL MODULE: ../../node_modules/@styled-system/css/dist/index.esm.js
var index_esm = __webpack_require__(26273);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ./src/old-marketing/components/Container.styles.ts



var StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(zephyr_esm/* Box */.xu).withConfig({
    componentId: "sc-32b62357-0"
})((0,index_esm/* default */.ZP)({
    maxWidth: 1224,
    mx: "auto",
    px: 32
}));

;// CONCATENATED MODULE: ./src/old-marketing/components/Container.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


/**
 * @deprecated Use `marketing/components/globals/container` instead.
 */ var Container = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, _objectSpread({}, props));
};


/***/ }),

/***/ 71119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ PreviewModeProvider; },
/* harmony export */   "s": function() { return /* binding */ usePreviewMode; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var PreviewModeContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var usePreviewMode = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(PreviewModeContext);
    if (context === undefined) {
        throw new Error("PreviewModeContext called outside of PreviewModeProvider");
    }
    return {
        isPreview: context.isPreview
    };
};
var PreviewModeProvider = function(param) {
    var children = param.children, value = param.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PreviewModeContext.Provider, {
        value: value,
        children: children
    });
};


/***/ }),

/***/ 50001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ GoogleTagManager; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_1__);


var GoogleTagManager = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_1___default()), {
        id: "gtm",
        strategy: "afterInteractive",
        children: "\n        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n        })(window,document,'script','dataLayer', '".concat("GTM-WZMSZFN", "');\n      ")
    });
};


/***/ }),

/***/ 5808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ clamp; }
});

;// CONCATENATED MODULE: ./src/utils/viewWidth.ts
var viewWidth = function(value) {
    var viewWidth1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1440;
    return Math.abs(value) / viewWidth1 * 100;
};

;// CONCATENATED MODULE: ./src/utils/clamp.ts

var clamp = function(min, max) {
    var vw = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1440;
    var isNegative = min < 0 || max < 0;
    var value = "clamp(".concat(Math.abs(min), "px, ").concat(viewWidth(max, vw), "vw ,").concat(Math.abs(max), "px)");
    return isNegative ? "calc(".concat(value, " * -1)") : value;
};


/***/ }),

/***/ 86250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ getContentfulUrl; }
/* harmony export */ });
/* provided dependency */ var process = __webpack_require__(93542);
var getContentfulUrl = function(id) {
    if (!id) {
        return "";
    }
    return "https://app.contentful.com/spaces/".concat(process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID, "/entries/").concat(id);
};


/***/ }),

/***/ 46445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ DemoDialog; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/plasmic-chilipiper/src/index.ts + 7 modules
var src = __webpack_require__(56111);
// EXTERNAL MODULE: ../../node_modules/@air/zephyr/dist/zephyr.esm.js + 90 modules
var zephyr_esm = __webpack_require__(55164);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/framer-motion.es.js + 37 modules
var framer_motion_es = __webpack_require__(77665);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@air/icons/dist/icons.esm.js
var icons_esm = __webpack_require__(74398);
// EXTERNAL MODULE: ../../node_modules/@reach/dialog/dist/dialog.esm.js + 29 modules
var dialog_esm = __webpack_require__(96973);
;// CONCATENATED MODULE: ../../packages/marketing-tech-debt/src/components/Dialog.ui.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var MotionDialogOverlay = framer_motion_es/* motion.custom */.ww.custom(dialog_esm/* DialogOverlay */.t9);
var MotionDialogContent = framer_motion_es/* motion.custom */.ww.custom(dialog_esm/* DialogContent */.cZ);
var DIALOG_OVERLAY_MOTION = {
    exit: {
        opacity: 0
    },
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1
    }
};
var DialogOverlay = /*#__PURE__*/ (0,react.forwardRef)(function(_param, forwardedRef) {
    var tx = _param.tx, restOfProps = _objectWithoutProperties(_param, [
        "tx"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, _objectSpread({
        animate: "animate",
        as: MotionDialogOverlay,
        exit: "exit",
        initial: "initial",
        ref: forwardedRef,
        tx: _objectSpread({
            zIndex: 1001,
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(38, 38, 38, 0.7)",
            overflow: "auto"
        }, tx),
        variants: DIALOG_OVERLAY_MOTION
    }, restOfProps));
});

DialogOverlay.displayName = "DialogOverlay";
var DialogOverlayClose = /*#__PURE__*/ (0,react.forwardRef)(function(_param, forwardedRef) {
    var tx = _param.tx, restOfProps = _objectWithoutProperties(_param, [
        "tx"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* IconButton */.hU, _objectSpread({
        icon: icons_esm/* Close */.x8P,
        ref: forwardedRef,
        size: "large",
        tx: _objectSpread({
            position: "fixed",
            top: [
                12,
                24
            ],
            right: [
                12,
                24
            ],
            backgroundColor: "pigeon700",
            color: "white",
            borderRadius: 100,
            "&:hover": {
                backgroundColor: "pigeon600",
                color: "white"
            }
        }, tx),
        variant: "button-ghost-grey"
    }, restOfProps, {
        children: "Close modal (ESC)"
    }));
});

DialogOverlayClose.displayName = "DialogClose";
var DIALOG_CONTENT_MOTION = {
    exit: {
        opacity: 0,
        y: 120
    },
    initial: {
        opacity: 0,
        y: 120
    },
    animate: {
        opacity: 1,
        y: 0
    }
};
var DialogContent = /*#__PURE__*/ (0,react.forwardRef)(function(_param, forwardedRef) {
    var children = _param.children, tx = _param.tx, restOfProps = _objectWithoutProperties(_param, [
        "children",
        "tx"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, _objectSpread({
        animate: "animate",
        as: MotionDialogContent,
        exit: "exit",
        initial: "initial",
        transition: {
            type: "spring",
            bounce: 0.2,
            duration: 0.4
        },
        tx: _objectSpread({
            position: "relative",
            backgroundColor: "white",
            width: "100%",
            maxWidth: 496,
            borderRadius: 8,
            mt: "10%",
            mb: [
                0,
                "10%"
            ],
            px: [
                24,
                56
            ],
            py: 56
        }, tx, {
            mx: "auto"
        }),
        variants: DIALOG_CONTENT_MOTION,
        ref: forwardedRef
    }, restOfProps, {
        children: children
    }));
});

DialogContent.displayName = "DialogContent";

;// CONCATENATED MODULE: ../../packages/marketing-tech-debt/src/components/Dialog.tsx
function Dialog_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Dialog_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Dialog_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Dialog_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Dialog_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Dialog_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var Dialog = function(_param) {
    var children = _param.children, _isOpen = _param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, onDismiss = _param.onDismiss, title = _param.title, description = _param.description, restOfProps = Dialog_objectWithoutProperties(_param, [
        "children",
        "isOpen",
        "onDismiss",
        "title",
        "description"
    ]);
    var closeButtonRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogOverlay, {
        isOpen: isOpen,
        initialFocusRef: closeButtonRef,
        onDismiss: onDismiss,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent, Dialog_objectSpread({
                "aria-labelledby": "dialog-title"
            }, restOfProps, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                        as: "h1",
                        id: "dialog-title",
                        tx: {
                            mb: 16,
                            color: "jay700",
                            textAlign: "center"
                        },
                        variant: "text-heading-32",
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                        as: "p",
                        tx: {
                            mb: 24
                        },
                        variant: "text-ui-16",
                        children: description
                    }),
                    children
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogOverlayClose, {
                onClick: onDismiss,
                ref: closeButtonRef
            })
        ]
    });
};


// EXTERNAL MODULE: ../../packages/analytics/src/index.ts + 42 modules
var analytics_src = __webpack_require__(64043);
// EXTERNAL MODULE: ../../packages/primitives/src/index.tsx + 20 modules
var primitives_src = __webpack_require__(89170);
// EXTERNAL MODULE: ../../node_modules/formik/dist/formik.esm.js + 109 modules
var formik_esm = __webpack_require__(70205);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
// EXTERNAL MODULE: ../../node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(24511);
;// CONCATENATED MODULE: ../../packages/marketing-tech-debt/src/components/Form.tsx
function Form_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Form_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Form_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Form_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Form_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Form_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var Form = (0,formik_esm/* connect */.$j)(function(_param) /*#__PURE__*/ {
    var _formik = _param.formik, handleReset = _formik.handleReset, handleSubmit = _formik.handleSubmit, props = Form_objectWithoutProperties(_param, [
        "formik"
    ]);
    return (0,jsx_runtime.jsx)("form", Form_objectSpread({
        onReset: handleReset,
        onSubmit: handleSubmit,
        noValidate: true
    }, props));
});
/** Formik-connected form. */ 
Form.displayName = "Form";

;// CONCATENATED MODULE: ../../packages/marketing-tech-debt/src/constants/routes.ts
/**
 * These are routes that are shared with app. Make sure to keep this up to date with app.
 */ var APP_BASE = "https://app.air.inc";
var MARKETING_BASE = "https://air.inc";
var SharedRoutes = {
    appStore: "https://itunes.apple.com/app/apple-store/id1244558410?pt=118626354&ct=aircamwebsite&mt=8",
    helpCenter: "https://help.air.inc",
    playStore: "https://play.google.com/store/apps/details?id=com.airapp.android",
    releases: "https://www.notion.so/aircamera/What-s-New-1d5da1c7779a4e71a94971834d5cdf0e",
    status: "https://status.air.inc/"
};
var AppRoutes = {
    library: "".concat(APP_BASE, "/library")
};
/**
 * These are social media routes.
 */ var SocialMediaRoutes = {
    github: "https://github.com/AirLabsTeam",
    instagram: "https://instagram.com/air.hq",
    linkedIn: "https://www.linkedin.com/company/airhq/",
    tiktok: "https://www.tiktok.com/@meetair",
    twitter: "https://twitter.com/airHQ",
    youtube: "https://www.youtube.com/channel/UCUgwosdkOa7oWs5wacfSTWQ"
};
var AuthRoutes = {
    signUp: "".concat(APP_BASE, "/sign-up"),
    login: "".concat(APP_BASE, "/login")
};
var Routes = {
    airShop: "https://shop.air.inc/",
    about: "".concat(MARKETING_BASE, "/about"),
    adobePremierePro: "".concat(MARKETING_BASE, "/adobe-premiere-pro"),
    adobePremiereProDownload: "https://partners.adobe.com/exchangeprogram/creativecloud/exchange.details.107604.html",
    agencies: "".concat(MARKETING_BASE, "/agencies"),
    blog: "".concat(MARKETING_BASE, "/blog"),
    careers: "https://apply.workable.com/air/",
    contentCleanersDigitalLibraryOrganizers: "".concat(MARKETING_BASE, "/content-cleaners-digital-library-organizers"),
    creatorProgram: "".concat(MARKETING_BASE, "/creator-program"),
    comparison: "".concat(MARKETING_BASE, "/comparison"),
    comparisonBrandExperience: "".concat(MARKETING_BASE, "/comparison/brand-experience"),
    comparisonCloudStorageAlternative: "".concat(MARKETING_BASE, "/comparison/cloud-storage-alternative"),
    comparisonDigitalAssetManagement: "".concat(MARKETING_BASE, "/comparison/digital-asset-management"),
    comparisonDropboxAlternative: "".concat(MARKETING_BASE, "/comparison/dropbox-alternative"),
    comparisonGoogleDriveAlternative: "".concat(MARKETING_BASE, "/comparison/google-drive-alternative"),
    comparisonBox: "".concat(MARKETING_BASE, "/comparison/box-alternative"),
    comparisonDAM: "".concat(MARKETING_BASE, "/comparison/digital-asset-management"),
    comparisonHardDrives: "".concat(MARKETING_BASE, "/comparison/hard-drives"),
    culture: "".concat(MARKETING_BASE, "/culture"),
    cultureManagement: "".concat(MARKETING_BASE, "/culture/management"),
    culturePolicies: "".concat(MARKETING_BASE, "/culture/policies"),
    customerStories: "".concat(MARKETING_BASE, "/customer-stories"),
    demo: "https://calendly.com/john_air/meetjohn",
    departmentDesignCreative: "".concat(MARKETING_BASE, "/department/design-creative"),
    departmentMarketing: "".concat(MARKETING_BASE, "/department/marketing"),
    departmentGrowth: "".concat(MARKETING_BASE, "/department/growth"),
    desktop: "".concat(MARKETING_BASE, "/air-lift"),
    diversity: "".concat(MARKETING_BASE, "/culture/diversity"),
    download: "".concat(MARKETING_BASE, "/download"),
    enterprise: "".concat(MARKETING_BASE, "/enterprise"),
    features: "".concat(MARKETING_BASE, "/features"),
    featuresDownloads: "".concat(MARKETING_BASE, "/features/downloads"),
    featuresDynamicFeedback: "".concat(MARKETING_BASE, "/features/dynamic-feedback"),
    featuresFlexibleOrganization: "".concat(MARKETING_BASE, "/features/flexible-organization"),
    featuresKanban: "".concat(MARKETING_BASE, "/features/kanban"),
    featuresSmartSearch: "".concat(MARKETING_BASE, "/features/smart-search"),
    featuresVersions: "".concat(MARKETING_BASE, "/features/versions"),
    featuresVisualWorkspace: "".concat(MARKETING_BASE, "/features/visual-workspace"),
    inclusion: "".concat(MARKETING_BASE, "/culture/inclusion"),
    industry: "".concat(MARKETING_BASE, "/industry"),
    industryAgencies: "".concat(MARKETING_BASE, "/industry/agencies"),
    industryAthletics: "".concat(MARKETING_BASE, "/industry/athletics"),
    industryEducation: "".concat(MARKETING_BASE, "/industry/education"),
    industryMedia: "".concat(MARKETING_BASE, "/industry/media"),
    industryNonprofits: "".concat(MARKETING_BASE, "/industry/nonprofits"),
    industryRetail: "".concat(MARKETING_BASE, "/industry/retail"),
    integrations: "".concat(MARKETING_BASE, "/integrations"),
    iphone: "https://apps.apple.com/app/apple-store/id1244558410",
    logos: "".concat(MARKETING_BASE, "/logos"),
    migrate: "".concat(MARKETING_BASE, "/switch"),
    operators: "".concat(MARKETING_BASE, "/operators"),
    pricing: "".concat(MARKETING_BASE, "/pricing"),
    privacy: "".concat(MARKETING_BASE, "/legal/privacy"),
    releaseNotes: "https://www.notion.so/airinc/What-s-New-on-Air-1d5da1c7779a4e71a94971834d5cdf0e",
    resources: "".concat(MARKETING_BASE, "/resources"),
    root: "".concat(MARKETING_BASE, "/"),
    security: "".concat(MARKETING_BASE, "/security"),
    store: "https://shop.air.inc",
    terms: "".concat(MARKETING_BASE, "/legal/terms"),
    tour: "".concat(MARKETING_BASE, "/tour"),
    tourCreativeApprovals: "".concat(MARKETING_BASE, "/tour/creative-approvals"),
    tourCreativeRequests: "".concat(MARKETING_BASE, "/tour/creative-requests"),
    tourOnboardFreelancers: "".concat(MARKETING_BASE, "/tour/onboard-freelancers"),
    tourRightsManagement: "".concat(MARKETING_BASE, "/tour/rights-management"),
    worthlessStudios: "".concat(MARKETING_BASE, "/blog/worthless-studios"),
    /**
   * Landing page routes. Subject to change
   */ semlp1forma: "".concat(MARKETING_BASE, "/landing/sem-lp-form-1"),
    semlp1formb: "".concat(MARKETING_BASE, "/landing/sem-lp-form-2"),
    semlp1buttona: "".concat(MARKETING_BASE, "/landing/sem-lp-button-1"),
    semlp1buttonb: "".concat(MARKETING_BASE, "/landing/sem-lp-button-2")
};
var BlogRoutes = {
    archive: "".concat(MARKETING_BASE, "/blog/archive"),
    categories: "".concat(MARKETING_BASE, "/blog/category"),
    home: "".concat(MARKETING_BASE, "/blog"),
    /**
   * These are routes that contains a custom page renderer.
   */ firstagram: "".concat(MARKETING_BASE, "/blog/1stagram"),
    nycRooftopBarsRestaurants: "".concat(MARKETING_BASE, "/blog/nyc-rooftop-bars-restaurants"),
    nycCreativeCouncil: "".concat(MARKETING_BASE, "/blog/nyc-creative-council"),
    sixFeetCalculator: "".concat(MARKETING_BASE, "/blog/6feetcalculator"),
    supportNYC: "".concat(MARKETING_BASE, "/blog/supportnycdtc"),
    creativeOps: "".concat(MARKETING_BASE, "/blog/category/creative-ops"),
    buildingBrands: "".concat(MARKETING_BASE, "/blog/category/building-brands"),
    airNews: "".concat(MARKETING_BASE, "/blog/category/air-news")
};

;// CONCATENATED MODULE: ../../packages/marketing-tech-debt/src/components/forms/ChilipiperDetailedForm.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ChilipiperDetailedForm_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ChilipiperDetailedForm_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ChilipiperDetailedForm_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}










var validationSchema = (0,es/* object */.Ry)({
    firstName: (0,es/* string */.Z_)().default("").required("First name is required"),
    lastName: (0,es/* string */.Z_)().default("").required("Last name is required"),
    email: src/* chilipiperEmailValidationSchema */.qm,
    company_size: (0,es/* string */.Z_)().default("").required("Company Size is required"),
    hearAbout: (0,es/* string */.Z_)().default(""),
    hearAboutOther: (0,es/* string */.Z_)().default("")
});
var selectStyles = {
    marginBottom: 24,
    minWidth: "unset",
    "> div": {
        backgroundColor: "white",
        borderRadius: 4
    }
};
var ChilipiperDetailedForm = function(param1) {
    var _buttonText = param1.buttonText, buttonText = _buttonText === void 0 ? "Book a demo" : _buttonText, id = param1.id, _isLabelHidden = param1.isLabelHidden, isLabelHidden = _isLabelHidden === void 0 ? false : _isLabelHidden, _leadsource = param1.leadsource, leadsource = _leadsource === void 0 ? src/* ChilipiperLeadsource.Default */.Vs.Default : _leadsource;
    var createLead = (0,src/* useChilipiper */.er)({
        router: id || src/* ChilipiperRouter.limit-fields-aug-22 */.Y_["limit-fields-aug-22"],
        leadsource: leadsource !== null && leadsource !== void 0 ? leadsource : src/* ChilipiperLeadsource.Default */.Vs.Default
    }).createLead;
    var trackClickedLeadFormSubmit = (0,analytics_src/* useTrackClickedLeadFormSubmit */.u1)().trackClickedLeadFormSubmit;
    var trackClickedLeadFormSubmit1To10 = (0,analytics_src/* useTrackClickedLeadFormSubmit1To10 */.Bi)().trackClickedLeadFormSubmit1To10;
    var trackClickedLeadFormSubmit11Plus = (0,analytics_src/* useTrackClickedLeadFormSubmit11Plus */.K)().trackClickedLeadFormSubmit11Plus;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: validationSchema.cast(undefined),
        onSubmit: function(values, param) {
            var setSubmitting = param.setSubmitting, resetForm = param.resetForm;
            trackClickedLeadFormSubmit(values);
            (0,analytics_src/* trackGTMEvent */.dG)({
                event: "Lead Form Submit",
                eventProps: ChilipiperDetailedForm_objectSpread({
                    label: "lead form submit",
                    category: "enterprise"
                }, values)
            });
            if ((values === null || values === void 0 ? void 0 : values["company_size"]) === "1-10") {
                trackClickedLeadFormSubmit1To10(values);
                (0,analytics_src/* trackGTMEvent */.dG)({
                    event: "Lead Form Submit (1-10)",
                    eventProps: ChilipiperDetailedForm_objectSpread({
                        label: "lead form submit",
                        category: "enterprise"
                    }, values)
                });
            } else {
                (0,analytics_src/* trackGTMEvent */.dG)({
                    event: "Lead Form Submit (11+)",
                    eventProps: ChilipiperDetailedForm_objectSpread({
                        label: "lead form submit",
                        category: "enterprise"
                    }, values)
                });
                trackClickedLeadFormSubmit11Plus(values);
            }
            createLead({
                values: ChilipiperDetailedForm_objectSpread({}, values),
                onSuccess: function() {
                    setSubmitting(false);
                    resetForm();
                }
            });
        },
        validationSchema: validationSchema,
        children: function(param) {
            var values = param.values;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives_src/* Box */.xu, {
                        css: {
                            display: "flex",
                            gap: 16,
                            marginBottom: 24,
                            flexDirection: "column",
                            "@laptop": {
                                flexDirection: "row"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Input */.II, {
                                autoComplete: "given-name",
                                label: "First name",
                                "data-testid": "CHILIPIPER_FORM_FIRST_NAME",
                                name: "firstName",
                                required: true,
                                tx: {
                                    flexGrow: 1,
                                    minWidth: "unset"
                                },
                                type: "text",
                                variant: "field-input-smol"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Input */.II, {
                                autoComplete: "family-name",
                                "data-testid": "CHILIPIPER_FORM_LAST_NAME",
                                label: "Last name",
                                name: "lastName",
                                required: true,
                                tx: {
                                    flexGrow: 1,
                                    minWidth: "unset"
                                },
                                type: "text",
                                variant: "field-input-smol"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Input */.II, {
                        autoComplete: "email",
                        "data-testid": "CHILIPIPER_FORM_EMAIL",
                        isLabelHidden: isLabelHidden,
                        label: "Business email",
                        name: "email",
                        placeholder: "Work email address",
                        required: true,
                        tx: {
                            width: "100%",
                            minWidth: "unset",
                            marginBottom: 24
                        },
                        type: "email",
                        variant: "field-input-smol"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* SingleSelect */.q4, {
                        "data-testid": "CHILIPIPER_FORM_COMPANY_SIZE",
                        label: "Company size",
                        name: "company_size",
                        options: [
                            {
                                label: "1-10",
                                value: "1-10"
                            },
                            {
                                label: "11-50",
                                value: "11-50"
                            },
                            {
                                label: "51-100",
                                value: "51-100"
                            },
                            {
                                label: "101-500",
                                value: "101-500"
                            },
                            {
                                label: "501-1000",
                                value: "501-1000"
                            },
                            {
                                label: "1001+",
                                value: "1001+"
                            }, 
                        ],
                        placeholder: "Company size",
                        required: true,
                        tx: ChilipiperDetailedForm_objectSpread({}, selectStyles, {
                            flexGrow: 1,
                            maxWidth: "unset",
                            marginBottom: 24
                        }),
                        variant: "field-input-smol"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* SingleSelect */.q4, {
                        "data-testid": "CHILIPIPER_FORM_HEAR_ABOUT",
                        label: "How did you first hear about us?",
                        name: "hearAbout",
                        options: _toConsumableArray((0,lodash.shuffle)([
                            {
                                label: "Event (virtual or IRL)",
                                value: "Event (virtual or IRL)"
                            },
                            {
                                label: "Podcast",
                                value: "Podcast"
                            },
                            {
                                label: "Twitter",
                                value: "Twitter"
                            },
                            {
                                label: "LinkedIn",
                                value: "LinkedIn"
                            },
                            {
                                label: "Newsletter/Email",
                                value: "Newsletter/Email"
                            },
                            {
                                label: "Blog or publication",
                                value: "Blog or publication"
                            },
                            {
                                label: "Referred by someone",
                                value: "Referred by someone"
                            },
                            {
                                label: "Advertisement",
                                value: "Advertisement"
                            },
                            {
                                label: "Search engine",
                                value: "Search engine"
                            }, 
                        ])).concat([
                            {
                                label: "Other",
                                value: "Other"
                            }, 
                        ]),
                        required: false,
                        tx: ChilipiperDetailedForm_objectSpread({}, selectStyles),
                        variant: "field-input-smol"
                    }),
                    values.hearAbout === "Other" && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Input */.II, {
                        "data-testid": "CHILIPIPER_FORM_HEAR_ABOUT_OTHER",
                        isLabelHidden: true,
                        label: "Please add more details",
                        name: "hearAboutOther",
                        placeholder: "Please add more details",
                        required: true,
                        tx: {
                            width: "100%",
                            minWidth: "unset",
                            marginTop: 16
                        },
                        type: "email",
                        variant: "field-input-smol"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Button */.zx, {
                        css: {
                            display: "block",
                            width: "100%",
                            marginTop: 32
                        },
                        "data-testid": "CHILIPIPER_FORM_SUBMIT",
                        size: "large",
                        type: "submit",
                        children: buttonText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives_src/* Text */.xv, {
                        as: "p",
                        css: {
                            marginTop: 24,
                            textAlign: "center"
                        },
                        size: "ui-14",
                        children: [
                            "By submitting the form, you agree to our",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Anchor */.ee, {
                                href: Routes.terms,
                                css: {
                                    fontSize: "inherit"
                                },
                                children: "Terms of Service"
                            }),
                            " ",
                            "and acknowledge our",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Anchor */.ee, {
                                href: Routes.privacy,
                                css: {
                                    fontSize: "inherit"
                                },
                                children: "Privacy Policy"
                            }),
                            "."
                        ]
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ../../packages/marketing-tech-debt/src/components/dialogs/DemoDialog.tsx







var DemoDialog = function(param) {
    var id = param.id, isOpen = param.isOpen, leadsource = param.leadsource, onDismiss = param.onDismiss;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* AnimatePresence */.M_, {
        children: isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog, {
            "data-testid": "DEMO_DIALOG",
            description: "Schedule a free demo today. One of our experts will show you how Air works.",
            isOpen: isOpen,
            onDismiss: onDismiss,
            title: "Let\u2019s talk!",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ChilipiperDetailedForm, {
                    id: id !== null && id !== void 0 ? id : src/* ChilipiperRouter.limit-fields-aug-22 */.Y_["limit-fields-aug-22"],
                    leadsource: leadsource
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                    as: framer_motion_es/* motion.div */.ww.div,
                    tx: {
                        position: "absolute",
                        bottom: 82,
                        left: -88,
                        display: [
                            "none",
                            "block"
                        ],
                        pointerEvents: "none"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: "",
                        height: 67,
                        src: "/marketing/assets/marketing/demo-dialog-cloud-1.svg",
                        width: 139
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                    tx: {
                        position: "absolute",
                        top: 170,
                        right: -103,
                        display: [
                            "none",
                            "block"
                        ],
                        pointerEvents: "none"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: "",
                        height: 65,
                        src: "/marketing/assets/marketing/demo-dialog-cloud-2.svg",
                        width: 137
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                    tx: {
                        position: "absolute",
                        top: -60,
                        left: -55,
                        display: [
                            "none",
                            "block"
                        ],
                        pointerEvents: "none"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: "",
                        height: 90,
                        src: "/marketing/assets/marketing/demo-dialog-macaroni.svg",
                        width: 65
                    })
                })
            ]
        })
    });
};


/***/ })

}]);